<!-- 优质图库 -->
<template>
    <div class="m-goodMap">
        <el-form class="page-query" :model="formSearch" :inline="true" size="mini" @submit.native.prevent>
            <el-form-item label="物品名称">
                <el-input v-model="formSearch.imageName" :placeholder="$t('tip.name')"
                          @keyup.enter.native="queryMap(1)" clearable></el-input>
            </el-form-item>

            <select-multi-mark-knowledge v-model="formSearch.knowledgeIds"></select-multi-mark-knowledge>

            <el-form-item label="时间">
                <advanced-date-picker v-model="formSearch.time" selector="select"></advanced-date-picker>
            </el-form-item>

            <select-multi-orgs v-if="userInfo.type === 1 || isBackend" v-model="formSearch.orgIds"></select-multi-orgs>

            <el-form-item>
                <el-button type="primary" @click="queryMap(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <div class="page-table">
            <div class="page-operate">
                <el-button-group>
                    <el-tooltip effect="dark" content="添加优质图像" placement="top" :hide-after="1000">
                        <el-button size="small" @click="addMap">
                            <i class="nucfont inuc-add"></i>
                        </el-button>
                    </el-tooltip>

                    <map-import @importSuccess="queryMap()"></map-import>

                    <el-tooltip v-show="isDeleteShow" class="item" effect="dark" :content="$t('c.delete')"
                                placement="top-end"
                                :hide-after="1000">
                        <el-button size="small" :title="$t('c.delete')" @click="deleteMap()">
                            <i class="nucfont inuc-delete"></i>
                        </el-button>
                    </el-tooltip>
                </el-button-group>

                <el-radio-group v-model="formSearch.isSafe" @change="queryMap(1)"
                                style="float: right;" size="small">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button :label="true">安全</el-radio-button>
                    <el-radio-button :label="false">嫌疑</el-radio-button>
                </el-radio-group>
            </div>

            <data-tables-server class="form-table map-table"
                                ref="omitMapTable"
                                :data="omitMapData"
                                :table-props="tableProps"
                                :total="page.total"
                                :current-page.sync="page.current"
                                :page-size="page.size"
                                :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                @query-change="onPage"
                                @selection-change="handleSelectionChange"
                                v-viewer
            >
                <!-- column checkbox -->
                <el-table-column type="selection" width="55px" :reserve-selection="true"
                                 align="center"></el-table-column>
                <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label" :width="title.width"
                                 align="center" :sortable="title.sortable">
                    <template v-if="title.prop==='markerUrl'" #default="{row}">
                        <div class="img-map">
                            <el-badge v-if="!row.isCompletion" class="unfinished" value="未完善">
                                <img v-if="row.isMark" :src="row.markerUrl" alt="">
                                <img v-else :src="row.baseUrl" alt="">
                            </el-badge>
                            <template v-else>
                                <img v-if="row.isMark" :src="row.markerUrl" alt="">
                                <img v-else :src="row.baseUrl" alt="">
                            </template>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('c.operation')" align="center" width="120">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview" :title="$t('c.view')" @click="viewMap(scope.row.id)"></i>
                        <i class="nucfont inuc-edit" :title="$t('c.edit')" @click="editMap(scope.row.id)"></i>
                        <!-- 删除权限：后台删后台 或者科室删自己创建的 -->
                        <i class="nucfont inuc-delete" v-if="isBackend || !isBackend && !scope.row.isBackstage && userID === scope.row.creatorId"
                           :title="$t('c.delete')" @click="deleteMap(scope.row.id)"></i>
                    </div>
                </el-table-column>
            </data-tables-server>
        </div>

        <map-detail-drawer :showID.sync="detailID"></map-detail-drawer>

    </div>
</template>

<script>
    import {Ticket} from '@/utils'
    import {mapGetters} from 'vuex'
    import AdvancedDatePicker from '@/components/DatePickerAdvanced'
    import selectMultiOrgs from '@/components/SelectMultiOrgs'
    import MapDetailDrawer from "./Components/MapDetailDrawer"
    import SelectMultiMarkKnowledge from "@/components/SelectMultiMarkKnowledge"
    import MapImport from "./Components/MapImport";

    export default {
        components: {
            AdvancedDatePicker,
            selectMultiOrgs,
            MapDetailDrawer,
            SelectMultiMarkKnowledge,
            MapImport
        },

        data() {
            return {
                isBackend: false, // 是否为后台(身份分为科室和后台)
                formSearch: {
                    imageName: '',
                    knowledgeIds: [],
                    time: {},
                    orgIds: '',
                    isSafe: '',
                },
                omitMapData: [],
                tableProps: {
                    //border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    //height: 'auto'
                },
                page: {
                    current: 1,
                    size: 20,
                    total: 0,
                },
                titles: [
                    {
                        prop: 'imageName',
                        label: '物品名称',
                    },
                    {
                        prop: 'markerUrl',
                        label: '物品照片',
                        width: 300
                    },
                    {
                        prop: 'knowledgeName',
                        label: '物品种类'
                    },
                    {
                        prop: 'inspectTime',
                        label: '过检时间',
                    },
                    {
                        prop: 'channel',
                        label: '通道号',
                    },
                    {
                        prop: 'watchName',
                        label: '安检员',
                    },
                    {
                        prop: 'articleStatusName',
                        label: '结果',
                    },
                    {
                        prop: 'creatorName',
                        label: '创建人',
                    },
                ],
                isDeleteShow: false,
                selectIds: [],
                detailID: 0,

                userID: Ticket.get().userID,
            }
        },

        computed: {
            ...mapGetters([
                'userInfo',
            ]),
        },

        mounted() {
            this.isBackend = this.$route.name === 'mapCollectBG'

            this.queryMap()
        },

        methods: {
            onPage({type, page, pageSize}) {
                if (type === 'init') return
                this.page.current = page
                this.page.size = pageSize
                this.queryMap()
            },
            queryMap(num) {
                if (num) this.page.current = num

                let searchData = {
                    ...this.formSearch,
                    startTime: this.formSearch.time[0],
                    endTime: this.formSearch.time[1],
                    PageNO: this.page.current,
                    Limit: this.page.size,
                    source: 2,
                }

                delete searchData.time

                let request = this.isBackend ? this.$api.queryOmitByBacker: this.$api.queryOmit
                request(searchData).then((res) => {
                    this.omitMapData = res.package
                    this.page.total = res.total

                    // this.omitMapData.forEach(item => {
                    //     if (!item.isSafe && !item.isMark) {
                    //         item.needMark = true
                    //     }
                    // })
                })
            },

            viewMap(id) {
                this.detailID = id
            },
            addMap() {
                let name = this.isBackend ? 'addGoodMapBG': 'addGoodMap'
                this.$router.push({name})
            },
            editMap(id) {
                let name = this.isBackend ? 'editGoodMapBG': 'editGoodMap'
                this.$router.push({name, params: {id}})
            },

            deleteMap(id) {
                let selectIds = this.selectIds
                if (id) selectIds = [id]

                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.$api.deleteOmit({
                        ids: selectIds,
                        isBackstage: this.isBackend,
                    }).then(() => {
                        this.$message.success(this.$t('m.delSuccess'))
                        this.isDeleteShow = false
                        this.queryMap()
                        this.$refs.omitMapTable.$refs.elTable.clearSelection()
                    }).catch(() => {})
                })
            },

            handleSelectionChange(arr) {
                this.selectIds = arr.map(v => v.id)
                this.isDeleteShow = this.selectIds.length > 0

                // let selectImageIds = arr.map(v => v.imageId)
                // this.$emit('good-select', selectImageIds)
                this.$emit('good-select', arr)
            },
            clearSelect() {
                this.$refs.omitMapTable.$refs.elTable.clearSelection()
            },
            handlePageChange() {
                $('#m-mapCollect .page-container').animate({scrollTop: 0}, 300)
            }
        },
    }
</script>

<style lang="scss">
    .m-goodMap {
        .img-map {
            .unfinished .el-badge__content {
                top: 12px;
                right: 24px;
            }
        }
    }
</style>
